module.exports = __webpack_public_path__ + "static/media/token-preview-dog.b7fb6ed1.png";